import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal, Icon, Tabs, Checkbox, Tag, message, Select} from 'antd';
import start from "./resourcePool/img/start.png";
import rename from "../view/Resource/img/edit-outlined.png"
import BaseComponent from "../../../base/BaseComponent";
import {resourceFormatDate, unitConvert} from '../../../utils/index'
import moment from "moment";
import {AUDIO_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../constants";
import {detailConfig} from "./detaiPageItem/detail-config";
import RelatedResources from "../components/detailPageRight/RelatedResources";
import RelationshipMap from '../components/detailPageRight/RelationshipMap'
import Version from '../components/detailPageRight/Version'
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from '../../../utils'
import blue from '../components/img/face_blue.png'
import red from '../components/img/face_red.png'
import Partake from "./Partake";
import '../components/resourcePool/resourcePool.css'
import MyIconSvg from "./svg/Svg";
import $ from "jquery";
const {TabPane} = Tabs;
const { Option } = Select;
const tabBarEle = {
    '1':'renderInformation',
    '2':'relationResource',
    '3':'renderAtlas',
    '4':'renderVersion'
}

export default class DetailPage extends BaseComponent {
    static defaultProps = {
        onRef: () => {
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            data: {},//当前数据
            JurisdictionList: [],//权限信息列表
            Information: {},//基本信息
            labelNames: [],//标签
            FileParentDirList: [],//存储路径

            tabList: [
                {
                    id: '1',
                    name: '基本信息',
                    show:true
                },
                {
                    id: '2',
                    name: '相关资源',
                    show:true
                },
                {
                    id: '3',
                    name: '关系图谱',
                    show:true,
                },
                {
                    id: '4',
                    name: '版本追踪',
                    show:false,
                }
            ],//获取的tab数据
            inputValue: '',
            whetherCollect: false,
            thisTabKey: '1',
            currentIndex:0,
            dataList:[],
            TagList:[],//标签
            selectLabel:[],//选择的label
            text:'',//输入的文字
            key:'',
            current:'1',
            mediaVisible:false,
            isShowText:false,//显示文字还是视频
            currentMedia:[],
            checked:false,
            isShowPublic:true, // 是否是公共资源 公共资源不显示不编辑按钮
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

        this.props.onRef(this)
    }

    show(IsShow, data, index,isShowPublic) {

        if(this.props.story){
            this.state.tabList[3].show = true;
            this.state.tabList[1].show = false
        }else{
            this.state.tabList[3].show = false;
            this.state.tabList[1].show = true
        }
        this.setState({});
        this.setState({visible: IsShow, data: data, currentIndex: index,selectLabel:[], current:'1',isShowPublic:isShowPublic}, () => {
            if(this.props.story){

                this.getStoryData()
            }else{

                this.getData()

            }

        })
    }
  //获取稿件库详情页的数据
    getStoryData(){
        this.getStoryInformation();
        this.getLabel();
    }
    //获取文件库  图片 视频  音频 其他 的详情页数据
   getData(){
       this.getJurisdictionList();
       this.getInformation();
       this.getLabel();
       this.getFileParentDirList();
       this.whetherCollect();

    }
    getTable(){
     let tabList= [
            {
                id: '1',
                name: '基本信息',
                show:true
            },
        ];
        this.setState({tabList:tabList})
    }

    render() {
        let {Information, whetherCollect,JurisdictionList} = this.state;
        let pic_type =  ["jpg","jpeg","png","bmp","webp","webp2","tiff","tif","JPG","JPEG","PNG","BMP","WEBP","WEBP2","TIFF","TIF"];
        //收藏
        let collectBtn = whetherCollect === false ? (
            <Button style={{marginRight: 15}} icon={"star"}
                    onClick={() => {
                        this.getCollect(Information && Information.id, Information && Information.name)
                    }}>
                收藏</Button>
        ) : (
            <Button style={{marginRight: 15}}
                    onClick={() => {
                        this.cancelCollect(Information && Information.id)
                    }}>
                <img src={start} style={{position: 'relative', top: '-3px', right: '3px'}}/>
                取消收藏</Button>
        );
        let face_recognition = this.sysConfigGetValueByKey("face_recognition.enable", "0");
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");
        let show = true;

        // let showVideoCutOut = Information.storageFile && [...VIDEO_TYPE].indexOf(Information.storageFile.suffix) > -1;
        if ([...PIC_TYPE].indexOf(Information?.storageFile?.suffix) === -1)  {
            show = false;
        }

        // if ([...PIC_TYPE].indexOf(Information?.storageFile?.suffix||Information?.suffix) === -1 && [...VIDEO_TYPE].indexOf(Information?.storageFile?.suffix||Information?.suffix) === -1 )  {
        //     show = false;
        // }
        return (
            <>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title="资源详情"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    width={1200}
                    centered
                    onCancel={() => {
                        if(typeof this.props.onCloseCall === 'function') {
                            this.props.onCloseCall()
                        }
                        this.setState({visible: false})
                    }}
                    footer={null}
                    className={"modalPadding"}
                >
                    <div style={{display: 'flex',}}>
                        <div style={{width: '70%',}}>
                            <div style={{display: 'flex', justifyContent: 'flex-end',paddingRight:"32px"}}>

                                {face_recognition==='1'&&pic_type.indexOf(this.state.data.suffix)>-1&&JurisdictionList.indexOf('个人资源') === -1? <Button id={'resourceManagement'}  style={{marginRight: 15}}><Checkbox checked={this.state.checked} onChange={(e)=>{
                                    this.setState({checked:e.target.checked},()=>{
                                        if(this.state.checked){
                                            this.faceRecognition()
                                        }else{
                                            $(".headBox").remove();
                                        }
                                    })
                                }}><span style={{color:newSecondSelectColor}}>标识人脸</span></Checkbox></Button>:null}


                                <Button style={{marginRight: 15}} icon={"download"}
                                        onClick={() => {
                                            if (this.props.story) {
                                                this.downLoadStory(this.state.data)
                                            } else {
                                                this.downLoad(this.state.data)
                                            }}}>
                                    下载</Button>
                                {/*收藏*/}
                                {this.props.story?null:collectBtn}
                                {this.props.story?null:  <Partake currentId={this.state.data && this.state.data.id} marginRight={15}
                                                                  checkArray={[this.state.data]} style={{marginRight: '10px'}} callBack={() => {
                                }}></Partake>}
                                {show&&this.state.isShowPublic?
                                    <Button
                                            icon={"edit"}
                                            onClick={() => {
                                                let path = this.state.Information.storageFile.path;
                                                this.editCover(path, "", (data) => {
                                                    this.okReplaceModal(data)
                                                })
                                            }}>编辑</Button> : null}

                            </div>

                            {this.state.isShowText?this.renderStory():this.renderFile()}
                        </div>

                        <div style={{width: '30%',maxHeight:"575px"}}>
                            <Tabs defaultActiveKey={"1"} activeKey={this.state.current}  onChange={this.change}>
                                {this.state.tabList.map((item, index) => {
                                  
                                    if(item.show){
                                        return (
                                            <TabPane tab={item.name} key={item.id}>
                                                <Scrollbars autoHide={true} autoHeight autoHeightMax={575}>
                                                    {this[tabBarEle[item.id]]()}
                                                </Scrollbars>
                                            </TabPane>
                                        )
                                    }

                                })}
                            </Tabs>
                        </div>
                    </div>
                </Modal>
                <style>
                    { `
                        .modalPadding .ant-modal-body {padding: 24px 0 24px 24px;}
                        #resourceManagement .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner{border-color:${newSecondSelectColor} !important}
                        #resourceManagement .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-input{outline:none !important}
                        .ant-checkbox-checked::after{border-color:${newSecondSelectColor}}
                        `}
                </style>
            </>

        )
    }
    renderStory(){
      let {Information} =this.state;
        return(
            <>
            <div id="detail-container-id" style={{
                height: "554px",
                marginTop: '13px',
                padding:'32px',
                background: 'rgba(0, 80, 179, 0.04)',
                overflowY:"scroll"
            }}>

               <div style={{fontSize:'20px',color:" rgba(0,0,0,0.85)",fontWeight: "bold"}}>{Information&&Information.title?Information.title:''}</div>
                <div style={{fontSize: "16px",
                    color: "rgba(0,0,0,0.45)",
                    marginTop:'16px',
                    width:"100%",

                }} className={'showTwoText'}>{Information&&Information.variableFields&&Information.variableFields.summary?Information.variableFields.summary:''}</div>
                <div style={{height:'24px',background:" rgba(229,237,247,0.39)",color:'rgba(0,0,0,0.45) !important',marginTop:"20px"}}>
                    <span style={{}}>{moment(Information&&Information.createTime?Information.createTime:'').format('YYYY-MM-DD' )}</span>
                    <span style={{marginLeft:'24px'}}>来源：{Information&&Information.source?Information.source:''}</span>
                </div>
                {/* <Scrollbars
                    autoHeight
                    autoHide
                    autoHeightMax={Information&&Information.variableFields&&Information.variableFields.summary?350:400}
                    style={{marginTop:20}}
                > */}
                    <div id="content-part-id" style={{paddingRight:10}} dangerouslySetInnerHTML={{ __html: Information&&Information.content?Information.content:'' }}/>
                {/* </Scrollbars> */}
            </div>
            <style>
                { `
                    #detail-container-id::-webkit-scrollbar{
                        width:5px;
                    }
                    #detail-container-id::-webkit-scrollbar-thumb{
                        border-radius: 3px;
                        background: #ccc;
                        height:100px
                    }
                    #detail-container-id::-webkit-scrollbar-track{
                        border-radius: 3px;
                        -webkit-box-shadow:inset 0 0 6px rgba(255,255,255,0.3)
                    }
                    #content-part-id img{
                        max-width:700px;
                        object-fit:cover
                    }
                `}
            </style>
            </>
        )
    }


    renderFile(){
        let id =this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id
        //预览
        let {Information} = this.state;
        let viewJs = null;
        let type = Information.storageFile && Information.storageFile.type;
        let configName = detailConfig[type];
        if (typeof configName == "string") {
            viewJs = require(`./detaiPageItem/${configName}`); // 引入编辑器
        }
        if(this.props.story){
            viewJs = require(`./detaiPageItem/detailVideo`); // 引入编辑器
        }
        viewJs = viewJs ? <viewJs.default detailData={Information} story={this.props.story} id={id}/> : <div></div>
        return(
            <div   style={{
                height: "554px",
                marginTop: '13px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'rgba(0, 80, 179, 0.04)'
            }}>
                {
                    this.state.currentIndex > -1 ?
                        <img style={{marginLeft: "16px",cursor: "pointer"}}
                             src={require('../components/detailPageRight/img/icon_back_big_2_left (1).png')}
                             onClick={() => {
                                 this.nextLeft()
                             }}
                        />
                        : <span></span>
                }
                <div style={{width: "80%", height: "80%",position:'relative'}} className={id}>
                    {viewJs}
                </div>
                {
                    this.state.currentIndex > -1 ?
                        <img style={{marginRight: "16px",cursor: "pointer"}}
                             src={require('../components/detailPageRight/img/icon_back_big_2_right_right.png')}
                             onClick={() => {
                                 this.nextRight()
                             }}
                        />
                        : <span></span>
                }
            </div>
        )
    }

    change=(key)=>{
        this.setState({current:key})
    };

    handleOk = e => {
        if(typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({
            visible: false,
        });
    };

    //下一个右侧
    nextRight() {
        //图片所有数据
        let newDataList=this.props.dataList.filter((item)=>{
            return item.fileTypeEnum === "FILE"
        });

        if(newDataList.length > 1){
            this.setState({current:"1"})
        }
        let dataList = this.props.dataList || [];
        let fileTypeEnum = this.state.data.fileTypeEnum;
        let currentIndex = this.state.currentIndex;
        currentIndex = this.getIndex(dataList, currentIndex,'add');
        if(this.state.currentIndex === currentIndex) return false;
        let currentData = dataList[currentIndex];
        if (!(currentData && currentData.id)) return false;
        this.state.data = currentData;
        this.state.currentIndex = currentIndex;
        this.getData()
    }


    editCover = (scr, name, call) => {
        if (scr) {
            if ([...PIC_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
                window.edit.callback = function (obj) {
                    call && call(obj)
                };
                window.edit.openEditPictureFrame(scr, name);
            } else if ([...VIDEO_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
                window.editer.editSuccessCallBack = function (obj) {
                    call && call(obj)
                };
                window.editer.open(scr, name);
            }
        } else {
            if ([...PIC_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
                console.log("待编辑图片地址丢失")
            } else if ([...VIDEO_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
                console.log("待编辑视频地址丢失")
            }
        }
    };

    replacePic(data, type) {
        let icon = data.thumbnailsPlayPath;
        if ([...PIC_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
            icon = data.path;
        }
        let body = {
            virtualFileId: this.state.Information.id,
            fid: this.state.Information.fid,
            icon: icon,
            md5: data.md5,
            size: data.size
        };
        let url = "/cm-sites-storage-management/editor/replace";
        if (type === 1) {
            url = "/cm-sites-storage-management/editor/rebuild";
        }
        this.request({
            url,
            method: "post",
            body,
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    this.getData();
                }
            }
        });
    }

    okReplaceModal(data) {
        let title = "是否替换原图片？";
        if ([...VIDEO_TYPE].indexOf(this.state.Information.storageFile.suffix) > -1) {
            title = "是否替换原视频？"
        }
        Modal.confirm({
            title: title,
            maskClosable: false,
            keyboard: false,
            okText: "是",
            cancelText: "否",
            onOk: () => {
                this.replacePic(data, 2)
            },
            onCancel: () => {
                this.replacePic(data, 1)
            }
        })
        this.setState({})
    }



    getIndexAdd = (list, i) => {
        let newList = list.slice(i+1,list.length);
        let index = newList && newList.length ? newList.findIndex(item=>(item.fileTypeEnum !== 'LINK' && item.fileTypeEnum !== 'DIR')) : -1;
        if(index>=0) {
            return index+i+1
        }
        let firstFileIndex = list.findIndex(item=>(item.fileTypeEnum !== 'LINK' && item.fileTypeEnum !== 'DIR'));
        return firstFileIndex>-1?firstFileIndex:i
    };
    getIndexMinus = (list, i) => {
        let newList = list.slice(0,i);
        let lastFileIndex = newList && newList.length ? newList.findLastIndex(item=>(item.fileTypeEnum !== 'LINK' && item.fileTypeEnum !== 'DIR')) : -1;
        let index = lastFileIndex>-1?lastFileIndex: -1;
        if(index>=0) {
            return index
        }
        return list.length-1
    };

    getIndex = (list, i, type) => {
        if (list && list.length) {
            if(type == 'add') {
                return this.getIndexAdd(list, i);
            } else {
                return this.getIndexMinus(list, i);
            }
        }
    };
    hasFile = (list) => {
        if(list && list.length) {
            return list.some(file => (file.fileTypeEnum !== 'LINK' && file.fileTypeEnum !== 'DIR'))
        }
        return false
    };

    //上一个左侧
    nextLeft() {
        let newDataList=this.props.dataList.filter((item)=>{
            return item.fileTypeEnum === "FILE"
        });
        if(newDataList.length > 1){
            this.setState({current:"1"})
        }
        let dataList = this.props.dataList || [];
        let currentIndex = this.state.currentIndex;
        currentIndex = this.getIndex(dataList,currentIndex,'del');
        if(this.state.currentIndex === currentIndex) return false;
        let currentData = dataList[currentIndex];
        if (!(currentData && currentData.id)) return false;
        this.state.data = currentData;
        this.state.currentIndex = currentIndex;

        this.getData()
    }

    //相关图谱
    renderAtlas() {
        return (
            <div style={{height: '550px', overflow: 'auto'}}>
                <RelationshipMap virtualFileId={this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id} story={this.props.story}/>
            </div>
        )
    }
    //版本追踪
    renderVersion(){
        return (
            <div style={{height: '550px', overflow: 'auto'}}>
                <Version id={this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id} callBack={(data)=>{
                    this.state.Information.title =data.title;
                    this.state.Information.content =data.content;
                    this.setState({})
                }}/>
            </div>
        )
    }
    //基本信息列表
    renderInformation() {

        let {JurisdictionList, Information, labelNames, FileParentDirList,TagList} = this.state;

        const children = [];
        TagList && TagList.length && TagList.map((item, index) => {
                if (item) {
                    children.push(<Option value={item.name} label={item.id} key={item.id}>{item.name}</Option>);
                }
            }
        );

        let num = Information.size;
        let duration = [...VIDEO_TYPE, ...AUDIO_TYPE].indexOf(Information.suffix) > -1 ? (
            <div style={{marginTop: '10px'}}>
                <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>时长：</span>
                <span>{moment(Information && Information.storageFile && Information.storageFile.duration ? Information.storageFile.duration : '').format('mm分ss秒')}</span>
            </div>
        ) : null;
        let pixel = [...PIC_TYPE].indexOf(Information.suffix) > -1 ? (
            <div style={{marginTop: '10px'}}>
                <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>像素：</span>
                <span style={{color:'rgba(0, 0, 0, 0.85)'}}> {Information && Information.storageFile && Information.storageFile.width ? Information.storageFile.width : ''} x {Information && Information.storageFile && Information.storageFile.height ? Information.storageFile.height : ''}</span>
            </div>
        ) : null;
        //途径,
        let channel,department,createTime,creatorName,photography,camera,editor,updateTime;
        let publishUrl =[];
        let mediaList = [];
        if(this.props.story){
            channel = Information.source;
             department =Information.deptName;
            createTime =Information.createTime;
            creatorName =Information.submitterName;
            photography = Information && Information.variableFields && Information.variableFields.photography ? Information.variableFields.photography : '';
            camera= Information && Information.variableFields && Information.variableFields.camera ? Information.variableFields.camera : '';
            editor =  Information && Information.variableFields && Information.variableFields.author ? Information.variableFields.author : '';
             publishUrl = Information && Information.media? Information.media : {};
            updateTime =  Information&&Information.updateTime?Information.updateTime:''
            for(let i in publishUrl ){
               for(let j  in  publishUrl[i]){
                   mediaList.push({
                       name:j,
                       obj: publishUrl[i][j]
                   })
               }
            }
        }else{
            channel = Information && Information.extendedAttributeJson && Information.extendedAttributeJson.source ? Information.extendedAttributeJson.source : '';
            department =Information && Information.extendedAttributeJson && Information.extendedAttributeJson.deptName ? Information.extendedAttributeJson.deptName : '';
            createTime =Information && Information.createTime ? Information.createTime : '';
            creatorName= Information && Information.extendedAttributeJson && Information.extendedAttributeJson.userName ? Information.extendedAttributeJson.userName : '';

        }
        return (
            <div style={{padding: '20px 20px 0 20px',fontSize:'14px'}}>
                <div style={{color: '#000000', fontWeight: 600}}>基本信息</div>
                {this.props.story?null: <div style={{marginTop: '10px'}} className={'twoText'}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>名称：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}} title={Information.name}>{Information && Information.name ? Information.name: ''}</span>
                    </div>}
                <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>途径：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}>{channel}</span>
                </div>
                <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>所属部门：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}>{department}</span>
                </div>
                <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>上传人：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}>{creatorName}</span>
                </div>
                <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>上传时间：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}>{moment(createTime).format('YYYY-MM-DD HH:mm:ss' )}</span>
                </div>
                {duration}
                {pixel}
                {this.props.story? <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>摄影：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}> {photography}</span>
                </div>:  <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>大小：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}> {unitConvert(num)}</span>
                </div>}
                {this.props.story?<div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>摄像：</span>
                    <span style={{color:'rgba(0, 0, 0, 0.85)'}}> {camera}</span>
                </div>:  <div style={{marginTop: '10px'}}>
                    <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>存储路径：</span>
                    {
                        FileParentDirList && FileParentDirList.length > 0 && FileParentDirList.map((item, index) => {
                            return (<span key={item} style={{color:'rgba(0, 0, 0, 0.85)'}}>{index == 0 ? "" : <Icon type="right"/>}{item}</span>)
                        })
                    }
                </div>}
                {this.props.story?<div style={{marginTop: '10px'}}>
                        <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>作者：</span>
                        <span style={{color:'rgba(0, 0, 0, 0.85)'}}> {editor}</span>
                    </div>:null}
                {this.props.story?   <div style={{marginTop: '20px', color: '#000000', fontWeight: 600}}>发布媒体</div>:   <div style={{marginTop: '20px', color: '#000000', fontWeight: 600}}>权限信息</div>}
                {this.props.story?
                    <div style={{marginTop: '14px'}}>
                        {
                            mediaList && mediaList.length > 0 && mediaList.map((item,index) => {
                                return (
                                    <div style={{display:'flex',justifyContent: "space-between",marginTop:'13px'}} key={index}>
                                        <div style={{width:'50%'}}  className={'twoText'}>
                                            <img src={item.obj[0].mediaLogoUrl} style={{width:'20px',height:'20px',objectFit: "contain"}}/>
                                            <span style={{marginLeft:'8px'}}>{item.name}</span>
                                        </div>
                                        {/*currentMedia*/}
                                        <div  style={{width:'40%'}}>{moment(updateTime).format('YYYY-MM-DD' )}</div>

                                        {Information.type !== 2?<div style={{color:" #0050B3",cursor:"pointer",width:'10%'}} onClick={()=>{
                                            this.state.currentMedia = item.obj;
                                            this.state.mediaVisible = true;
                                            this.setState({})
                                        }}>查看</div>:null}


                                    </div>)
                            })
                        }
                    </div>
                    :    <div style={{marginTop: '14px'}}>
                    {
                        JurisdictionList && JurisdictionList.length > 0 && JurisdictionList.map((item) => {
                            return (<span key={item} style={{marginLeft: "10px",color:'rgba(0, 0, 0, 0.85)'}}>{item}</span>)
                        })
                    }
                </div>}
                <div style={{marginTop: '20px', color: '#000000', fontWeight: 600}}>标签</div>
                <div style={{marginTop: '12px',color:'rgba(0, 0, 0, 0.85)'}} key={this.state.key}>
                    <Select
                        autoFocus
                        destroyOnClose={true}
                        mode="tags"
                        autoClearSearchValue={true}
                        size={this.state.size}
                        placeholder="请输入或选择标签"
                        value ={this.state.selectLabel}
                        onChange={(value)=>{
                            this.handleChange(value)
                        }}
                        // onInputKeyDown={(e) => {
                        //     if (e.key === 'Enter' && e.target.value) {
                        //       this.addLabel()
                        //     }
                        // }}
                        onFocus={()=>{
                            this.setState({TagList:[],key:''})
                        }}
                        style={{ width: '70%' }}
                        onSearch={(value)=>{
                            // this.setState({text:value});
                            this.getLabelByName(value)}}
                    >
                        {children}
                    </Select>
                    <Button style={{marginLeft: "10px"}} onClick={() => {
                        this.getLabelAdd(this.state.selectLabel, Information.id)
                    }}>添加</Button>
                </div>
                <div style={{marginTop: '9px'}}>
                    {
                        labelNames.map((item) => {
                            let name = item.name;
                            if(name.length>20){
                                name =name.substring(0, 20) +'....';
                            }
                            return (
                                <Tag key={item.id+(new Date().getTime())} title={item.name} closable={item.delete?false:true} color={item.color} style={{marginBottom: '9px'}} onClose={() => {
                                    this.removeLabel(item,Information.id)
                                }}>{name}</Tag>
                            )
                        })
                    }
                </div>
                <Modal
                    title="发布地址列表"
                    visible={this.state.mediaVisible}
                    footer={null}
                    onCancel={()=>{
                        this.setState({mediaVisible:false})
                    }}
                >
                    <div>{
                        this.state.currentMedia&&this.state.currentMedia.length&&this.state.currentMedia.map((item,index)=>{
                            return (
                                <div style={{display:'flex',justifyContent: 'space-between'}}>
                                    <div style={{width:'25%'}} className={'twoText'} title={item.contentName||item.mediaName}>{item.contentName||item.mediaName}</div>
                                    <div style={{cursor:'pointer',color:"#1890ff"}} onClick={()=>{
                                        window.open(item.linkUrl)
                                    }}>{item.linkUrl}</div>
                                </div>
                            )
                            })
                    }</div>

                </Modal>
            </div>
        )
    }
    addLabel=()=>{
        let array =JSON.parse(JSON.stringify(this.state.selectLabel)) ;
        // if(this.state.text&&array.indexOf(this.state.text)===-1){
        //     array.push(this.state.text)
        // }

        this.setState({selectLabel:array,key:uuid(),text:''},()=>{

        })
    };
    handleChange = selectLabel => {
        let array =[];
        selectLabel&&selectLabel.length&&selectLabel.forEach((item,index)=>{
            let name = item.trim()
            if(name.length>50){
                    name = name.substring(0, 50) ;
            }
            let pattern = new RegExp('[\/:*?"<>|]')
            let  rs = "";
            for (var i = 0; i < name.length; i++) {
                rs = rs + name.substr(i, 1).replace(pattern, '');
            }
            let newName =rs.trim()
            if(newName.length){
                array.push(newName)
            }
        });
        this.setState({ selectLabel:array })
    };
    //标签联动
    getLabelByName = (value) => {
        if(value){
            this.request({
                url: '/cm-sites-storage-management/label/searchByName',
                method: "post",
                body: {
                    searchByName: value,
                },
                contentType: "json",
                callBack: (data) => {
                    let searchByName = [];
                    if (data) {
                        searchByName = data
                    }
                    this.setState({TagList:searchByName})
                }
            });
        }else{
            this.setState({TagList:[]})
        }
    };
    //相关资源列表
    relationResource() {
        return (
            <RelatedResources virtualFileId={this.state.Information.id}/>
        )
    }
    //权限列表
    getJurisdictionList() {
        this.request({
            url: '/cm-sites-storage-management/zykFile/getPermissionList',
            method: "get",
            body: {
                id: this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id,
            },
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    this.setState({JurisdictionList: data})
                }
            }
        });
    }
    //基本信息
    getInformation() {
        let body = {
            id: this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id,
        };
        this.request({
            url: '/cm-sites-storage-management/zykFile/getDetailById',
            body,
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    this.setState({Information: data},()=>{
                        $('.headBox').remove();
                        let face_recognition = this.sysConfigGetValueByKey("face_recognition.enable", "0");
                        let {JurisdictionList} = this.state;
                        let pic_type =  ["jpg","jpeg","png","bmp","webp","webp2","tiff","tif","JPG","JPEG","PNG","BMP","WEBP","WEBP2","TIFF","TIF"];
                        if(this.state.checked&&face_recognition==='1'&&pic_type.indexOf(this.state.data.suffix)>-1&&JurisdictionList.indexOf('个人资源') === -1){
                            this.faceRecognition()
                        }


                    });
                }
            }
        });
    }
    getStoryInformation(){
        this.request({
            url: '/search-server/search/getByThirdId',
            method: "get",
            body: {
                thirdId: this.state.data.id,
            },
            callBack: (data) => {
                if (data) {
                   if(data.atlasList&&data.atlasList.length){
                         message.destroy();
                         message.warning('组图文章，请在图片库中查看')
                   }
                    if(data.type === 4|| data.type === 5){
                        this.state.isShowText = false
                    }else{
                        this.state.isShowText = true
                    }
                    let publishUrl = data&&data.publishUrl&&data.publishUrl.length?data.publishUrl:[];
                    let media = {};
                    publishUrl&&publishUrl.length&&publishUrl.forEach((item,index)=>{
                        let type = item.mediaType;
                        let mediaName = item.mediaName;
                        if(!media[type]){media[type] = {}}
                        if(!media[type][mediaName]){
                            media[type][mediaName] = []
                        }
                        media[type][mediaName].push(item)

                    });
                    data.media =media;
                    this.state.Information = data;
                    this.setState({});
                }
            }
        });
    }
    // 标签
    getLabel = () => {
        this.request({
            url: '/cm-sites-storage-management/label/getLabelNames',
            method: "get",
            body: {
                id: this.state.data.virtualFileId ? this.state.data.virtualFileId : this.state.data.id,
            },
            contentType: "json",
            callBack: (data) => {
                let labelNames = [];
                if (data) {
                    labelNames = data
                }
                this.setState({labelNames})
            }
        });
    };
    //添加标签
    getLabelAdd = (labelNames, virtualFileIds) => {
        let  label = labelNames;
        this.request({
            url: this.props.story?'/cm-sites-storage-management/zykFile/addFileLabels':'/cm-sites-storage-management/zykFile/addLabels',
            method: "post",
            body: {
                labelNames: label.join(','),
                virtualFileIds: virtualFileIds
            },
            contentType: "json",
            callBack: (data) => {
                if(!data)return message.error('添加失败！');
                this.getLabel()
                this.setState({selectLabel:[]})
            },
        })
    };
    // 删除标签
    removeLabel=(labelNames,virtualFileId)=>{
        this.request({
            url: '/cm-sites-storage-management/zykFile/removeLabel',
            method: "post",
            body: {
                labelNames: labelNames.name,
                virtualFileId:virtualFileId
            },
            contentType: "json",
            callBack: (data) => {

            },
        })
    };
    // 存储路径
    getFileParentDirList() {
        this.request({
            url: '/cm-sites-storage-management/zykFile/fileParentDirList',
            method: "get",
            body: {
                id: this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id,
            },
            contentType: "json",
            callBack: (data) => {
                let FileParentDirList = [];
                if (data) {
                    FileParentDirList = data
                }
                this.setState({FileParentDirList})
            }
        });
    }
    //downLoad  下载
    downLoad(){
        let {data,Information}=this.state
        if(data.extendedAttributeJson&&data.extendedAttributeJson.download){
            message.error('所选资源为未公开资源，请申请下载！')
        }else{
             this.downloadFile(Information && Information.storageFile && Information.storageFile.md5,Information.name)

        }
    }
    //稿件详情页开启人脸下载
    downLoadStory(){
        this.request({
            url: "/cm-sites-storage-management/home/downloadStory",
            method: "downloadPost",
            body: [this.state.data],
            loading: false,
            contentType: 'json',
            callBack: (data) => {

            }
        });
    }
    downloadFile(md5,name){
        let { Information }=this.state;
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body:{
                virtualFileId:this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id,
                name:name,
                downloadFlag:false
            },
            contentType:'json',
            callBack: (data) => {
                if(data){
                    let url =  "/storage/downloadFile?md5="+md5+'&download=1'+'&name='+name;
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download','');
                    aObj.setAttribute('href',url);
                    aObj.click();
                    aObj = null
                }
                let fileType = '';
                if(PIC_TYPE.indexOf(Information.storageFile.suffix)>-1) {
                    fileType = 1;
                }else if(VIDEO_TYPE.indexOf(Information.storageFile.suffix)>-1){
                    fileType = 2;
                }else if(AUDIO_TYPE.indexOf(Information.storageFile.suffix)>-1){
                    fileType = 3;
                }else {
                    fileType = 4;
                }
                let body = {
                    id:Information.id,
                    fileName:Information.name,   //String 文件名称
                    fileIcon:Information.icon,   //String 文件显示缩略图
                    type:fileType,        //Integer 文件类型 参考前面保持一致
                    md5:Information.storageFile?.md5,         //String 文件的md5
                    size:Information.size,        //long  文件大小
                }
                this.request({
                    url: "/cm-sites-storage-management/zykStatistics/addDownloadRecords",
                    method: "post",
                    body:body,
                    contentType:'json',
                })
            }
        });
    }
    //是否收藏
    whetherCollect = () => {
        this.request({
            url: '/cm-sites-storage-management/zykCollection/checkCollection',
            method: "get",
            contentType: 'json',
            body: {
                virtualFileId:  this.state.data.virtualFileId?this.state.data.virtualFileId:this.state.data.id,
            },
            callBack: (data) => {
                let whetherCollect = false;
                if (data) {
                    whetherCollect = data
                }
                this.setState({whetherCollect})
            }
        });
    }
    //添加收藏
    getCollect = (virtualFileId, name) => {
        this.request({
            url: '/cm-sites-storage-management/zykCollection/add',
            method: "post",
            contentType: 'json',
            body: {
                virtualFileId: virtualFileId,
                name: name
            },
            callBack: (data) => {
                this.whetherCollect();
                this.setState({})
            },
        });
    };
    //取消收藏
    cancelCollect = (virtualFileId) => {
        this.request({
            url: '/cm-sites-storage-management/zykCollection/cancelDetailCollection',
            method: "get",
            contentType: 'json',
            body: {
                virtualFileId: virtualFileId,
            },
            callBack: (data) => {
                this.whetherCollect()
                this.setState({})
            },
        });
    };
    //开启人脸
    faceRecognition = (data) => {
        let id = this.state.data.virtualFileId ? this.state.data.virtualFileId : this.state.data.id;
        let src = this.state.Information.storageFile.path? this.state.Information.storageFile.path: this.state.Information.icon;

        this.loadIconWidthAndHeight(src).then(({width, height}) => {
            let boxWidth = $('.' + id).width();  //盒子的宽
            let boxHeight = $('.' + id).height();  //盒子的高

            let defaultWidth = $('#' + id).width();//图片的宽度
            let defaultHeight = $('#' + id).height();//图片的宽度
            //如果图片的宽高是0   那么不走下面的接口
            if (defaultWidth === 0 && defaultHeight === 0) {
                return
            }
            // if (width > height) {
            //     defaultHeight = $('#' + id).width() / width * height;
            //     if (defaultHeight > $('#' + id).height()) {
            //         defaultHeight = $('#' + id).height()
            //     }
            //     return defaultHeight
            // } else {
            //     defaultWidth = $('#' + id).height() / height * width;
            //     return defaultWidth
            // }
            let _this = this;
            _this.request({
                url: '/cm-sites-storage-management/face/image/faces?id=' + id,
                method: "get",
                contentType: 'json',
                callBack: (data) => {
                    if (!data.length) {
                        message.destroy();
                        message.warning('图中未识别出人脸，请重新选择图片')
                    } else {

                        let dataList = data;
                        dataList && dataList.length && dataList.forEach((item, index) => {
                            let faceWidth = item.image_width;//人脸数据的宽度；
                            let faceHeight = item.image_height;//人脸数据的高度；
                            let widthThan = defaultWidth / faceWidth;//计算图片实际的宽度占人脸参考的比 (用图片的宽除以人脸识别出来的人脸的宽)
                            let heightThan = defaultHeight / faceHeight;//计算图片实际的高度占人脸参考的比(用图片的高除以人脸识别出来的人脸的高)
                            //定义起始偏移量left；
                            let startWidth;
                            if (boxWidth < defaultWidth) {   //如果盒子的宽度小于图片的宽度
                                startWidth = item.bbox[0] * widthThan + 'px';//图片的宽度要乘以比例
                            } else {
                                startWidth = (boxWidth - defaultWidth) / 2 + (item.bbox[0]) * widthThan + 'px';//实际宽度不算比列，图片的宽度要乘以比例
                            }
                            //定义偏移量top；
                            var startHeight;
                            if (boxHeight < defaultHeight) {
                                startHeight = item.bbox[1] * heightThan + 'px';//实际高度不算比例，图片的高度乘以比
                            } else {
                                startHeight = (boxHeight - defaultHeight) / 2 + (item.bbox[1]) * heightThan + 'px';//实际高度不算比例，图片的高度乘以比例
                            }
                            let name = '';
                            let clickStatus = false;//人物头像是否可以双击  图形 00 点在左上角    01 确定 第一个点 左上角  23 确定第二个点右下角
                            let divWidth = (item.bbox[2] - item.bbox[0]) * widthThan + 'px';//新增div框的宽度
                            let divHeight = (item.bbox[3] - item.bbox[1]) * heightThan + 'px';//新增div框 的高度

                            let face_id = item.face_id;
                            if (item.label && item.label.length > 0) {
                                name = item.label[0];//设置名字
                                //	color = '#1E9FFF';//没有名字，设置头像框为蓝色
                                clickStatus = false;//有标签名就不可以双击
                                $('.' + id).append('<div   class="headBox" clickStatus="' + clickStatus + '"  face_id="' + face_id + '" imgId="' + id + '"  title="' + name + '" style=";width: ' + divWidth + ';height: ' + divHeight + ';position:absolute;left:' + startWidth + ';top:' + startHeight + ';cursor: pointer;">' +
                                    '<img style="width: ' + divWidth + ';height: ' + divHeight + ';" src=' + blue + '>' +
                                    '</div>');
                            } else {
                                name = '双击人脸设置人物名称';
                                //		color = 'red';//没有名字，设置头像框为红色
                                clickStatus = true;//无标签名可以双击
                                $('.' + id).append('<div   class="headBox"  clickStatus="' + clickStatus + '" face_id="' + face_id + '" imgId="' + id + '"  title="' + name + '" style=";width: ' + divWidth + ';height: ' + divHeight + ';position:absolute;left:' + startWidth + ';top:' + startHeight + ';cursor: pointer;">' +
                                    '<img style="width: ' + divWidth + ';height: ' + divHeight + ';"src=' + red + '>' +
                                    '</div>');
                            }
                            $('#' + id).click(function () {
                                $('.inputEnter').remove();
                            });

                            $(".headBox").click(function () {
                                $(".inputEnter").focus();
                            });
                            $('.headBox').dblclick(function () {
                                let clickBoxFace_id = $(this).attr("face_id");
                                //判断是否有输入框
                                let hasInputStatus = $('#inputName').hasClass('inputEnter');
                                //判断是否已有输入框，已有输入框完成操作后才能再次增加输入框
                                if (!hasInputStatus) {
                                    let that = $(this);
                                    let dblClickStatus = $(this).attr('clickStatus');
                                    if (dblClickStatus === 'true') {
                                        that.append('<input id="inputName" class="inputEnter" face_id="' + clickBoxFace_id + '" imgId="' + id + '"  placeholder="回车保存人物名称"/>');//给点击处增加输入框
                                        $('.inputEnter').css({height:"32px",zIndex:"999",position: "absolute",});
                                        $('.inputEnter >input-placeholder').css({color:"red"});
                                        $(".inputEnter").focus();//双击后输入框直接获取焦点输入
                                        //enter 键保存数据
                                        $(".inputEnter").keydown(function (e) {
                                            if (e.keyCode === 13) {
                                                let inputValue = $('.inputEnter').val();//获取输入框的值
                                                if (inputValue.length > 0 && inputValue.trim().length > 0) {
                                                    _this.request({
                                                        url: "/cm-sites-storage-management/face/label",
                                                        method: 'POST',
                                                        contentType: 'json',
                                                        body: {
                                                            "face_id": clickBoxFace_id,
                                                            "label": [inputValue],
                                                        },
                                                        callBack: async (data) => {
                                                            if (data) {
                                                                $(".headBox").remove();
                                                                _this.getLabel();
                                                                _this.setState({checked:false});
                                                                message.destroy();
                                                                message.success('人物名称设置成功！');
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        });
                                    }
                                } else {
                                    message.destroy();
                                    message.warning('请在已有的输入框输入哦！')
                                }
                            })
                        })
                    }
                },
            });
        });

    };
    loadIconWidthAndHeight = async (url)=>{
        return new Promise((resolve) => {
            let img = document.createElement("img");
            img.src = url;
            img.onload = () => {
                // 为什么要写 onload  是因为要等他加载完之后才能获取到图片宽高
                let obj = {width:img.naturalWidth,height: img.naturalHeight};
                resolve(obj);
            };
        });
    }
}